import axios from "@/index";
const newQrCode = {
  state: {
    cardList: [],
    fileList: [],
    testList: [],
    cardInfoData: []
  },
  getters: {},
  actions: {
    getCardList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit("setCardList", (state, { cardList: response.data }));
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getFileList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit("setFileList", (state, { fileList: response.data }));
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getTestList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit("setTestList", (state, { testList: response.data }));
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getCardInfo: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit("setCardInfo", (state, { cardInfoData: response.data }));
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  mutations: {
    setCardList(state, action) {
      state.cardList = action.cardList;
    },
    setFileList(state, action) {
      state.fileList = action.fileList;
    },
    setTestList(state, action) {
      state.testList = action.testList;
    },
    setCardInfo(state, action) {
      state.cardInfoData = action.cardInfoData;
    }
  }
};
export default newQrCode;
